// extracted by mini-css-extract-plugin
export default {"root":"X1ED0MzCnv","content":"vi3SXks7gc","pageTitle":"Aon5pBI2SO","noResults":"_xUzZa_NJz","sections":"lroQ28L82S","sectionHeader":"XpXi0kqcFZ","sectionTitle":"WfByon364w"};